import React, { useState } from "react";
import { FaUserFriends, FaVideo, FaCalendarCheck } from "react-icons/fa";
import { toast } from "react-toastify";

const BookSessionForm = () => {
    const [formData, setFormData] = useState({
        fullName: "",
        mobile: "",
        email: "",
        sessionType: "Online",
        date: "",
    });
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await fetch('https://100billionrealestate.com/therapist-rutika/contact', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData)
            });

            if (!response.ok) throw new Error('Submission failed.');

            const result = await response.json();
            toast.success('Message sent successfully!');

            setFormData({ name: '', email: '', mobile: '', message: '' });
        } catch (error) {
            toast.error('Failed to send message. Try again later.');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="session-section">
            <div className="session-content">
                {/* Left Column - Text */}
                <div className="session-text">
                    <h2 className="session-text-title">Book a Session with Us</h2>
                    <p className="session-text-description">
                        Taking the first step towards therapy can feel overwhelming, but
                        we’re here to make the process as smooth as possible. Whether you
                        prefer an <strong>online</strong> or <strong>offline</strong>{" "}
                        session, simply fill out the form, and we’ll connect with you to
                        finalize the details.
                    </p>
                    <p className="session-text-description">
                        Together, we’ll work to create a safe and supportive environment
                        where you can begin your journey toward healing and growth.
                    </p>

                    <div className="session-feature">
                        <FaUserFriends className="session-feature-icon" />
                        <div>
                            <h3 className="session-feature-title">Personalized Support</h3>
                            <p className="session-feature-desc">
                                Sessions tailored to your unique needs and challenges.
                            </p>
                        </div>
                    </div>

                    <div className="session-feature">
                        <FaVideo className="session-feature-icon" />
                        <div>
                            <h3 className="session-feature-title">Online & Offline Options</h3>
                            <p className="session-feature-desc">
                                Flexible sessions available both virtually and in person.
                            </p>
                        </div>
                    </div>

                    <div className="session-feature">
                        <FaCalendarCheck className="session-feature-icon" />
                        <div>
                            <h3 className="session-feature-title">Easy Scheduling</h3>
                            <p className="session-feature-desc">
                                Pick a date that works for you—confirmation after discussion.
                            </p>
                        </div>
                    </div>
                </div>

                {/* Right Column - Form */}
                <div className="session-form-container">
                    <h2 className="session-form-title">Book a Session</h2>
                    <form onSubmit={handleSubmit} className="session-form">
                        <div className="session-form-group">
                            <label className="session-form-label">Full Name</label>
                            <input
                                type="text"
                                name="fullName"
                                value={formData.fullName}
                                onChange={handleChange}
                                className="session-form-input"
                                placeholder="Enter your full name"
                                required
                            />
                        </div>

                        <div className="session-form-group">
                            <label className="session-form-label">Mobile No</label>
                            <input
                                type="tel"
                                name="mobile"
                                value={formData.mobile}
                                onChange={handleChange}
                                className="session-form-input"
                                placeholder="e.g. +91 9876543210"
                                required
                            />
                        </div>

                        <div className="session-form-group">
                            <label className="session-form-label">Email ID</label>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                className="session-form-input"
                                placeholder="example@email.com"
                                required
                            />
                        </div>

                        <div className="session-form-group">
                            <label className="session-form-label">Session Type</label>
                            <div className="session-type-options">
                                <label>
                                    <input
                                        type="radio"
                                        name="sessionType"
                                        value="Online"
                                        checked={formData.sessionType === "Online"}
                                        onChange={handleChange}
                                    />{" "}
                                    Online
                                </label>
                                <label>
                                    <input
                                        type="radio"
                                        name="sessionType"
                                        value="Offline"
                                        checked={formData.sessionType === "Offline"}
                                        onChange={handleChange}
                                    />{" "}
                                    Offline
                                </label>
                            </div>
                        </div>

                        <div className="session-form-group">
                            <label className="session-form-label">Preferred Date</label>
                            <input
                                type="date"
                                name="date"
                                value={formData.date}
                                onChange={handleChange}
                                className="session-form-input"
                                placeholder="Select a preferred date"
                                required
                            />
                            <p className="session-form-note">
                                *Exact date & time will be confirmed after discussion
                            </p>
                        </div>

                        {
                            loading ? <button type="button" className="session-form-button">
                                Submiting..
                            </button> : <button type="submit" className="session-form-button">
                                Submit
                            </button>
                        }

                    </form>
                </div>

            </div>
        </section>
    );
};

export default BookSessionForm;
